import { render, staticRenderFns } from "./faceComponents.vue?vue&type=template&id=5b88c0ad&scoped=true&lang=pug&"
import script from "./faceComponents.vue?vue&type=script&lang=js&"
export * from "./faceComponents.vue?vue&type=script&lang=js&"
import style0 from "./faceComponents.vue?vue&type=style&index=0&id=5b88c0ad&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88c0ad",
  null
  
)

export default component.exports